import React from 'react';
import css from '../../../../styles/modules/PaymentSummary/infocard.module.css';
import capitalizeWords from '../../lib/capitalizeWords';

export default function StatusTag({ status }) {
  function returnTagColor() {
    if (status?.toLowerCase() === 'completed') {
      return css.greyTag;
    } else if (status?.toLowerCase() === 'error') {
      return css.redTag;
    } else if (status?.toLowerCase() === 'pending') {
      return css.yellowTag;
    } else if (status?.toLowerCase() === 'sent') {
      return css.greenTag;
    } else {
      return css.greenTag;
    }
  }

  return (
    <div className={`${css.statusTag} ${returnTagColor()}`}>
      <p className={css.tagText}>{capitalizeWords(status)}</p>
    </div>
  );
}
